import Vue from 'vue'
import ViewUI from '@components/iview'
import formCreate from '@form-create/iview4'
import App from './App.vue'
import router from './router'
import http from './http/http'
import 'view-design/dist/styles/iview.css'
import "./assets/style/reset.less"
import "./assets/style/common.less"
import "./assets/style/flex.less"
import "./assets/style/self-quill-editor.css"
import md5 from 'js-md5' // MD5加密
import permission from './directives/permission';

// 需求所以引入
import "element-ui/lib/theme-chalk/index.css"
import ElementUI, { Tree } from 'element-ui'

import { statusSort, formatDate, yearformatDate } from "@utils/dataHandling"
import SearchArea from "@components/SearchArea.vue"
import TableArea from "@components/TableArea.vue"
import TableWrapper from "@components/TableWrapper.vue"

import moment from 'moment'

import UserBehaviorModal from "@components/UserBehaviorModal.vue"
import QueryUser from "@components/QueryUser.vue"
import Chart from "@components/Chart.vue"
import VueAMap from 'vue-amap'
import GpsMapModal from '@components/GpsMapModal.vue';

Vue.use(Tree) // 日期转换
Vue.prototype.$moment = moment

Vue.prototype.formatDate = formatDate
Vue.prototype.yearformatDate = yearformatDate

Vue.config.productionTip = false
/**
 * @description 全局相关注册
 */
Vue.use(ElementUI)
Vue.use(ViewUI)
Vue.use(formCreate)
Vue.use(http)

/** 全局通用组件 */
Vue.component('SearchArea', SearchArea)
Vue.component('TableArea', TableArea)
Vue.component('TableWrapper', TableWrapper)
Vue.component('UserBehaviorModal', UserBehaviorModal)
Vue.component('QueryUser', QueryUser)
Vue.component('Chart', Chart)
Vue.component('GpsMapModal', GpsMapModal)

window._AMapSecurityConfig = {
  // serviceHost:"https://portal.dev.meetuvip.com/_AMapService"
  securityJsCode: '68370aff48c14e284f6620277f218d18'
}
Vue.use(VueAMap)
// 初始化高德地图的 key 和插件
VueAMap.initAMapApiLoader({
  key: '79131112f22dfeb91f933c121a19a90b',
  plugin: ['AMap.Autocomplete', 'AMap.Geolocation', 'AMap.AMapUI', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.CitySearch'],
  v: '1.4.4',
  uiVersion: "1.1"
})

/** 顶部路由加载进度条 */
router.beforeEach((to, from, next) => {
  // 权限判断
  let hasPermission = true
  if (!to.meta.ignoreAuth && window.userInfo && window.userInfo.resource && window.userInfo.resource.menus) {
    let menus = window.userInfo.resource.menus
    if (menus && menus.length > 0) {
      let paths = []
      menus.forEach(menu => {
        if (menu.children && menu.children.length > 0) {
          menu.children.forEach(c => paths.push(c.attr.url))
        }
      })
      if (!paths.includes(to.path)) {
        hasPermission = false
      }
    } else {
      hasPermission = false
    }
  }
  if (hasPermission) {
    Vue.prototype.$Loading.start()
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    next()
  } else {
    next('/404')
  }
  Vue.prototype.$Loading.start()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

router.afterEach(routers => {
  Vue.prototype.$Loading.finish()
})

Vue.filter('dateFmt', (input, formatString = "YYYY-MM-DD") => {
  // es5函数参数设置默认值
  // const lastFormatString = formatString || ''

  // moment(input) 把时间字符串转成时间对象
  // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString)
})

/** 全局mixin**/
Vue.mixin({
  methods: {
    // reset() {
    //   this.$refs["searchData"].resetFields();
    //   this.search();
    // },
    statusSort
  }
})

Vue.directive('permission', permission)

const userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}')
window.userInfo = userInfo
window.md5 = md5

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
